var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"simple-button",attrs:{"to":_vm.to}},[_vm._t("default"),_c('span',{staticClass:"icon decors-icons-cta-arrow"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }